module.exports = __webpack_public_path__ + "media/icons/video-arrow-up-right-light-b4c3086a.svg";